import Typography from '@mui/material/Typography';
import ReplayIcon from '@mui/icons-material/Replay';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Session from '../shared/Session';
import {DateTimeWidget} from './DateTimeWidget';
import EditIcon from '@mui/icons-material/Edit';


export default function TaskView(props: any) {
    var key = props.task.id;

    return (<div id={key}>
        <Typography variant="h6" align="left" gutterBottom component="h6">
            <Tooltip title="Run Task Once Now">
                <IconButton size="small" color="inherit" style={{ margin: "3px !important" }} onClick={() => {
                    Session.rerunTask(props.task);
                }}>
                    <ReplayIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Edit Task">
                <IconButton size="small" color="inherit" style={{ margin: "3px !important" }} onClick={() => {
                    Session.navigate("/tasks/edit/" + props.task.id);
                }}>
                    <EditIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete Forever">
                <IconButton size="small" color="inherit" style={{ margin: "3px !important" }} onClick={() => {
                    (document.getElementById(key) as HTMLElement).style.display = "none";
                    Session.api("DELETE", "/tasks/" + props.task.id, {}, null, null, false);
                }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>
            {props.task.name} {props.task.function}
        </Typography>
        Next Execution: {props.task.execution_recurring && <DateTimeWidget dt={props.task.next_execution_datetime} />}
        {props.task.running && <Typography variant="body1" align="left" gutterBottom>
            Task is enqueued to execute!
        </Typography>}
        <Typography variant="body1" align="left" gutterBottom>Parameters: {JSON.stringify(props.task.parameters, null, 4)}</Typography>
        <br/>
    </div>)
}
